import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import AddressInput from "./AddressInput";

const ContactForm = ({ handleSubmit, address, includeDetails }) => {
  const {
    register,
    handleSubmit: onSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    defaultValues: {
      address,
    },
  });

  useEffect(() => {
    setValue("address", address);
  }, [address, setValue]);

  const watchedAddess = watch("address");

  const onSubmitWithReset = async (data) => {
    await handleSubmit(data);
    reset();
  };

  return (
    <form
      onSubmit={onSubmit(onSubmitWithReset)}
      className="font-maison-neue font-regular flex flex-col gap-2.5"
    >
      <label className="text-primary lg:text-xl leading-none font-normal flex flex-col gap-1">
        Property address
        <Controller
          name="address"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <AddressInput
              address={watchedAddess}
              setAddress={(newAddress) => setValue("address", newAddress)}
              isForm
              {...field}
            />
          )}
        />
      </label>
      {errors.address && <p className="text-red-500">Address is required</p>}

      <input
        type="text"
        placeholder="Name"
        name="full_name"
        autoComplete="name"
        {...register("name", { required: "Name is required" })}
        className="rounded-none w-full px-5 py-4 bg-transparentBlack focus:outline-none lg:text-xl placeholder:text-primary placeholder:text-opacity-30"
      />
      {errors.name && <p className="text-red-500">{errors.name.message}</p>}

      <input
        type="email"
        placeholder="Email"
        {...register("email", {
          required: "Email is required",
          pattern: {
            value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
            message: "Invalid email format",
          },
        })}
        className="rounded-none w-full px-5 py-4 bg-transparentBlack focus:outline-none lg:text-xl placeholder:text-primary placeholder:text-opacity-30"
      />
      {errors.email && <p className="text-red-500">{errors.email.message}</p>}

      <input
        type="tel"
        placeholder="Phone"
        {...register("phone", {
          required: "Phone is required",
          pattern: {
            value: /^\d{8,}$/,
            message: "Phone number must be at least 8 digits",
          },
        })}
        className="rounded-none w-full px-5 py-4 bg-transparentBlack focus:outline-none lg:text-xl placeholder:text-primary placeholder:text-opacity-30"
      />
      {errors.phone && <p className="text-red-500">{errors.phone.message}</p>}

      {includeDetails && (
        <>
          <label className="text-primary lg:text-xl leading-none font-normal flex flex-col gap-1">
            Subject
            <input
              type="text"
              {...register("subject", { required: "Subject is required" })}
              className="rounded-none w-full px-5 py-4 bg-transparentBlack focus:outline-none lg:text-xl"
            />
          </label>
          {errors.subject && (
            <p className="text-red-500">{errors.subject.message}</p>
          )}

          <label className="text-primary lg:text-xl leading-none font-normal flex flex-col gap-1">
            Message
            <textarea
              {...register("message", { required: "Message is required" })}
              className="rounded-none w-full px-5 py-4 bg-transparentBlack focus:outline-none lg:text-xl"
              rows="4"
            ></textarea>
          </label>
          {errors.message && (
            <p className="text-red-500">{errors.message.message}</p>
          )}
        </>
      )}

      <div className="w-full lg:w-auto">
        <button
          type="submit"
          className="w-full lg:w-auto font-maison-mono font-normal lg:px-16 py-4 mt-5 bg-primary text-white"
        >
          SUBMIT
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
